import { authHeaders, baseUrl, handleResponse } from './apiUtils';

export const EMPTY_TEACHER_EXTENSIONS = {
  studentsReadAll: false,
  clientsReadAll: false,
  classesManageScope: 'none',
};

function getCurrentAccess() {
  return fetch(`${baseUrl}permissions/me`, { headers: authHeaders() }).then(response => handleResponse(response, false));
}

function getCandidates(classId, q = '', cursor = '') {
  const params = new URLSearchParams({ classId, q });
  if (cursor) params.set('cursor', cursor);
  return fetch(`${baseUrl}classstudents/candidates?${params.toString()}`, { headers: authHeaders() }).then(handleResponse);
}

function saveLessonOrganization(lessonId, details) {
  return fetch(`${baseUrl}lessonregister/${encodeURIComponent(lessonId)}/organization`, {
    method: 'PUT', headers: authHeaders({ 'content-type': 'application/json' }), body: JSON.stringify(details),
  }).then(handleResponse);
}

export default { getCurrentAccess, getCandidates, saveLessonOrganization };
